export const toEntityWriteValue = (value) => {
  if (value == null) return null;
  if (typeof value === "object") return value;
  return String(value);
};
